import { useRef, useState } from "react";

const SR = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);
const WAKE = /\b(sem|sam|cem|sen)\s?(i\s?a|ya)\b|semia|samia|cemia|semya|\b(hey|he|eh|ok)\s(sem|sam|cem)\b/;

const normalize = (t) => t.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z\s]/g, " ").replace(/\s+/g, " ");

export const isWakePhrase = (t) => WAKE.test(normalize(t));

export default function useWakeWord(onWake, onError) {
  const [listening, setListening] = useState(false);
  const rec = useRef(null);
  const want = useRef(false);
  const cb = useRef({ onWake, onError });
  cb.current = { onWake, onError };

  const start = () => {
    if (!SR || want.current) return;
    want.current = true;
    const r = new SR();
    r.lang = "fr-FR";
    r.continuous = true;
    r.interimResults = true;
    r.onresult = (e) => {
      for (let i = e.resultIndex; i < e.results.length; i++) {
        if (isWakePhrase(e.results[i][0].transcript)) {
          stop();
          cb.current.onWake();
          return;
        }
      }
    };
    r.onerror = (e) => {
      if (e.error === "not-allowed" || e.error === "service-not-allowed") {
        want.current = false;
        cb.current.onError?.();
      }
    };
    r.onend = () => {
      if (want.current) {
        try { r.start(); } catch { /* already started */ }
      } else setListening(false);
    };
    rec.current = r;
    try { r.start(); setListening(true); } catch { want.current = false; }
  };

  const stop = () => {
    want.current = false;
    rec.current?.abort();
    rec.current = null;
    setListening(false);
  };

  return { supported: !!SR, listening, start, stop };
}

export function chime() {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  [660, 880].forEach((f, i) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = f;
    g.gain.setValueAtTime(0.0001, ctx.currentTime + i * 0.12);
    g.gain.exponentialRampToValueAtTime(0.2, ctx.currentTime + i * 0.12 + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + i * 0.12 + 0.25);
    o.connect(g).connect(ctx.destination);
    o.start(ctx.currentTime + i * 0.12);
    o.stop(ctx.currentTime + i * 0.12 + 0.3);
  });
  setTimeout(() => ctx.close(), 800);
}
